import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatDate } from "../../utils/helps";
import { getExcerpt } from "../../utils/html";

const ActivitiesArticleBoxByCategory = ({ article }) => {
  const logo = useSelector((state) => state.logo.logo);

  const isNotification = article.type === "notification";

  const imageUrl = isNotification
    ? logo
    : article?.images?.[0]?.url
      ? `${process.env.REACT_APP_API_URL}media/${article.images[0].url}`
      : "/placeholder.jpg";

  const link = isNotification
    ? `/thong-bao/${article?.category?.slug}/${article?.slug}`
    : `/post/${article?.slug}`;

  return (
    <div className="group flex flex-col">
      <Link to={link} className="flex flex-col">
        <h2 className="text-lg md:text-xl font-bold leading-snug group-hover:text-blue-700 transition-colors duration-300 mb-3 line-clamp-2 min-h-[3.6rem]">
          {article?.title}
        </h2>

        <div className="flex flex-row gap-4">
          <div className="w-[120px] h-[90px] md:w-[150px] md:h-[100px] flex-shrink-0 overflow-hidden">
            <img
              src={imageUrl}
              alt={article?.title}
              className={`w-full h-full ${article?.type == "notification" ? "object-contain" : "object-cover"} group-hover:scale-105 transition-transform duration-500`}
              loading="lazy"
            />
          </div>

          <div className="flex flex-col justify-between flex-1">
            <p className="text-xs text-gray-500 mb-2">
              {formatDate(article?.updatedAt)}
            </p>
            <p className="text-sm text-gray-700 line-clamp-3 text-justify">
              {article?.summary || getExcerpt(article?.content)}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ActivitiesArticleBoxByCategory;
